/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Catholic_Theology21Inputs */

const en__field_enum_study_catholic_theology21 = /** @type {(inputs: _Field_Enum_Study_Catholic_Theology21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catholic Theology`)
};

const de__field_enum_study_catholic_theology21 = /** @type {(inputs: _Field_Enum_Study_Catholic_Theology21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katholische Theologie`)
};

/**
* | output |
* | --- |
* | "Catholic Theology" |
*
* @param {_Field_Enum_Study_Catholic_Theology21Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_catholic_theology21 = /** @type {((inputs?: _Field_Enum_Study_Catholic_Theology21Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Catholic_Theology21Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_catholic_theology21(inputs)
	return de__field_enum_study_catholic_theology21(inputs)
});
export { _field_enum_study_catholic_theology21 as "_field_enum_STUDY_CATHOLIC_THEOLOGY" }